module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/online-collector-5.1d583aec.svg";